var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImportant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.6875C10.9609 1.6875 6.33203 4.38281 3.8125 8.71875C1.29297 13.1133 1.29297 18.4453 3.8125 22.7812C6.33203 27.1758 10.9609 29.8125 16 29.8125C20.9805 29.8125 25.6094 27.1758 28.1289 22.7812C30.6484 18.4453 30.6484 13.1133 28.1289 8.71875C25.6094 4.38281 20.9805 1.6875 16 1.6875ZM16 30.75C10.6094 30.75 5.6875 27.9375 2.99219 23.25C0.296875 18.6211 0.296875 12.9375 2.99219 8.25C5.6875 3.62109 10.6094 0.75 16 0.75C21.332 0.75 26.2539 3.62109 28.9492 8.25C31.6445 12.9375 31.6445 18.6211 28.9492 23.25C26.2539 27.9375 21.332 30.75 16 30.75ZM21.918 12.3516L14.418 19.8516C14.2422 20.0273 13.9492 20.0273 13.7734 19.8516L10.0234 16.1016C9.84766 15.9258 9.84766 15.6328 10.0234 15.457C10.1992 15.2812 10.4922 15.2812 10.668 15.457L14.125 18.8555L21.2734 11.707C21.4492 11.5312 21.7422 11.5312 21.918 11.707C22.0938 11.8828 22.0938 12.1758 21.918 12.3516Z",
    fill: "#0D63CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImportant);
export default __webpack_public_path__ + "static/media/icon_important.46980bf245d4fca7eaaf777ac46ac813.svg";
export { ForwardRef as ReactComponent };